import { Pipe, PipeTransform } from '@angular/core';
import { ComplianceDocumentStatusEnum } from '@cp/shared/data-access/http/compliance/compliance-http.models';
import { ComplianceStatusEntry } from '../interfaces/compliance-status.interface';

@Pipe({
  name: 'isExpiredDocument',
  pure: true,
})
export class IsExpiredDocumentPipe implements PipeTransform {
  public transform(statuses: Array<ComplianceStatusEntry>): boolean {
    const dueNowStatus = statuses.find(
      (status) => status.documentStatus === ComplianceDocumentStatusEnum.dueNow,
    );
    return dueNowStatus ? dueNowStatus.counter > 0 : false;
  }
}
